import Clarity from '@microsoft/clarity';

export const CLARITY_USER_ACTIONS = {
    INVOICES_POPUP_CONNECTED: 'invoices_popup_connected',
    DOCUMENT_CREATED: 'document_created',
    CUSTOMER_ADDED: 'customer_added',
    PRODUCT_ADDED: 'product_added',
};

const ANGULAR_FRESHPAINT_EVENT_TO_CLARITY_USER_ACTION = {
    'Add New Product Type': CLARITY_USER_ACTIONS.PRODUCT_ADDED,
    'Add new member': CLARITY_USER_ACTIONS.CUSTOMER_ADDED,
};

const trackClarityEvent = (eventName) => {
    try {
        if (!process.env.REACT_APP_CLARITY_PROJECT_ID) {
            return;
        }
        Clarity.event(eventName);
    } catch (error) {
        console.log('clarity error', error);
    }
};

export const setClaritySignupStep = (step) => {
    trackClarityEvent(`signup_${step}`);
};

export const setClarityUserAction = (action) => {
    trackClarityEvent(action);
};

export const trackClarityUserActionFromFreshpaintEvent = (eventName) => {
    const action = ANGULAR_FRESHPAINT_EVENT_TO_CLARITY_USER_ACTION[eventName];
    if (action) {
        setClarityUserAction(action);
    }
};

export const initClarity = () => {
    const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
    if (!projectId) {
        return;
    }
    Clarity.init(projectId);
};
